import React from "react";
import "./UploadProgressBar.css";

const UploadProgressBar = ({ progress }) => {
  return (
    <div className="form-group-2">
      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};

export default UploadProgressBar;
